export enum GiftTicketOrderableByEnum
  {
  FEMALE_EMPLOYEES = 1,
  MALE_EMPLOYEES = 2,
  CHILD_BENEFICIARIES = 3,
  ADULT_BENEFICIARIES = 4,
  SELF = 5,
}

export enum County {
  WholeCountry,
  AB, // Alba
  AR, // Arad
  AG, // Argeș
  BC, // Bacău
  BH, // Bihor
  BN, // Bistrița-Năsăud
  BR, // Brăila
  BT, // Botoșani
  BV, // Brașov
  B,  // București
  BZ, // Buzău
  CS, // Caraș-Severin
  CL, // Călărași
  CJ, // Cluj
  CT, // Constanța
  CV, // Covasna
  DB, // Dâmbovița
  DJ, // Dolj
  GL, // Galați
  GR, // Giurgiu
  GJ, // Gorj
  HR, // Harghita
  HD, // Hunedoara
  IL, // Ialomița
  IS, // Iași
  IF, // Ilfov
  MM, // Maramureș
  MH, // Mehedinți
  MS, // Mureș
  NT, // Neamț
  OT, // Olt
  PH, // Prahova
  SM, // Satu Mare
  SJ, // Sălaj
  SB, // Sibiu
  SV, // Suceava
  TR, // Teleorman
  TM, // Timiș
  TL, // Tulcea
  VS, // Vaslui
  VL, // Vâlcea
  VN  // Vrancea
}

export enum NotificationType {
  Danger = 0,
  Warning = 1,
  Success = 2,
  Info= 3,
  Primary = 4,
  Secondary = 5,
  Dark = 6
}

export enum BenefitHistoryType {
  None = 0,
  Order = 1,
  Subscription = 2,
  AutoOrder = 3,
  Insurance = 4,
}

export enum AutoOrderState {
  Active = 0,
  Inactive
}

export enum TwoFactorResendProvider {
  Email = 1,
  Phone = 2
}

export enum BenefitPaymentType {
  Budget = 1,
  CreditCard = 2,
  BudgetAndCreditCard = 3,
  Salary = 4,
  BudgetAndSalary = 5
}

export enum BudgetAvailabilityType {
  NoOfDays = 0,
  Fixed = 1
}

export enum RaiffeisenFormData {
  EMPLOYER = "employer",
  BRANCH = "branch"
}
